import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import About from './pages/About';
import RD from './pages/RD';
import Tome from './pages/Tome';
import TomeMobile from './pages/TomeMobile';
import Yummers from './pages/Yummers';
import Navbar from './components/Navbar';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about" element={<About />} />
        <Route path="/rd" element={<RD />} />
        <Route path="/tome" element={<Tome />} />
        <Route path="/tomemobile" element={<TomeMobile />} />
        <Route path="/yummers" element={<Yummers />} />
      </Routes>
    </BrowserRouter>
  );
}
